import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class AddSharingDialog extends React.Component {
  state = {
    email: "",
    person: null,
    loading: false,
    loading_check: false,
    valid: false
  }

  onEmailChanged = () => event => {
    var email = event.target.value;
    // Check validity
    if (this.isValidEmail(email) || email === "admin") {
      this.setState({ email: email, loading_check: true });

      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('accept', 'json')
        .send({ command: "getdatafromemail", email: email })
        .end((err, res) => {
          var result = res.text.trim();
          if (result !== "[]") {
            var obj = JSON.parse(result)[0];
            currentComponent.setState({ loading_check: false, person: obj, valid: true });
          } else {
            currentComponent.setState({ loading_check: false, valid: false });
          }
        });
    } else {
      this.setState({ email: email, loading_check: false, valid: false });
    }
  }

  onClose = person => {
    this.onReset();
    this.props.onAddPerson(person);
  }

  onReset = () => {
    this.setState({ email: "", person: null, loading: false, loading_check: false });
  }

  isValidEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render() {
    const { classes, fullScreen } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open} maxWidth="xs">
        <DialogTitle>{"Freigabe hinzufügen"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>Wichtig: Die Person muss bereits ein Nutzerkonto besitzen. Hier muss die selbe E-Mail Adresse wie bei der Erstellung des Nutzerkontos angegeben werden.</DialogContentText>
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <Input
              value={this.state.email}
              onChange={this.onEmailChanged()}
              type="email"
              endAdornment={
                <InputAdornment position="end">
                  {this.state.email.length > 0 && !this.state.loading_check && <IconButton>{this.state.valid ? <DoneIcon style={{ color: "green" }} /> : <ErrorIcon color="error" />}</IconButton>}
                  {this.state.email.length > 0 && this.state.loading_check && <CircularProgress size={20} />}
                </InputAdornment>
              }
              autoFocus />
            <FormHelperText id="standard-weight-helper-text">E-Mail der Person für die die Freigabe erstellt werden soll</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.onClose(null)}>Abbrechen</Button>
          <Button onClick={() => this.onClose(this.state.person)} variant="contained" disabled={this.state.loading || !this.state.valid} color="primary">
            Person hinzufügen
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

AddSharingDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onAddPerson: PropTypes.func.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(AddSharingDialog));
